import getAttachment from '../selectors/getAttachment';
import AttachmentModel from '../store/schema/AttachmentModel';
import { GDRIVE } from '../utils/attachmentConstants';
import getGDriveItemThumbnailUrl from '../utils/getGDriveItemThumbnailUrl';
import { isCloudyAttachmentType } from '../utils/isCloudyAttachment';
import { getAttachmentUrl } from 'owa-attachment-url';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentUrlType from 'owa-files-url/lib/schema/AttachmentUrlType';
import { action } from 'satcheljs/lib/legacy';

export default action('refreshThumbnailImageUrl')(async function refreshThumbnailImageUrl(
    attachmentId: ClientAttachmentId,
    isReadyOnly: boolean,
    addIsDownloadQueryParam: boolean = false
) {
    const attachment: AttachmentModel = getAttachment(attachmentId);

    if (isCloudyAttachmentType(attachment.model)) {
        switch (attachment.model.ProviderType) {
            case GDRIVE:
                try {
                    const url = await getGDriveItemThumbnailUrl(attachment.model);
                    attachment.thumbnailImage.url = url;
                } catch (e) {
                    attachment.thumbnailImage.url = null;
                }
                break;
            default:
                // We don't do anything for any other provider
                break;
        }
    } else {
        const url = getAttachmentUrl(
            attachmentId,
            attachment.model,
            AttachmentUrlType.Thumbnail,
            isCloudyAttachmentType(attachment.model),
            isReadyOnly,
            addIsDownloadQueryParam
        );

        attachment.thumbnailImage.url = url;
    }
});
